import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Modal from "react-bootstrap/Modal";
import { compareAsc, format } from 'date-fns'
import moment from "moment";
function EmpLeaveCom() {
    let navigate = useNavigate();
    let SERVER_URL = process.env.REACT_APP_API_URL;
    let BASE_URL = process.env.REACT_APP_APP_URL;
    let token = JSON.parse(localStorage.getItem('key'));
    const userId = localStorage.getItem('userId');
    const [holidaylist, setHolidaylist] = useState([]);
    const [modalstatus, setModalstatus] = useState(false);
    const [leave_type, setLeave_type] = useState('0')
    const [fromdate, setFromdate] = useState()
    const [todate, setTodate] = useState()
    const [duration, setDuration] = useState()
    const [half, setHalf] = useState(false)
    const [reason, setReason] = useState();
    const [err, setErr] = useState('');
    const [errmsg, setErrmsg] = useState('');
    const [msg, setMsg] = useState('');
    const [errfromdatemsg, setErrfromdatemsg] = useState('');
    const [errtodatemsg, setErrtodatemsg] = useState('');
    const [leave, setLeave] = useState({});
    const [leavelist, setLeavelist] = useState([])
    const [id, setId] = useState('');
    const [modalcomment, setModalcomment] = useState(false);
    const [att_remark, setAtt_remark] = useState('')
    const [date_select, setDate_select] = useState('');
    const HandleLeaveModal = () => {
        setModalstatus(true)
    }
    const handleClose = () => {
        setModalcomment(false)
        setAtt_remark('')
        setModalstatus(false)
        setErr('')
        setMsg('')
        setMsg('')
        setReason('')
        setLeave_type('0')
        setId('')
        setFromdate('')
        setTodate('')
    }


    useEffect(() => {
        getholidayList()
        getEmpLeave()
    }, [])

    const getEmpLeave = async () => {
        const response = await fetch(SERVER_URL + `api/attendance/leave-balance-list`,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'authorization': `bearer ${token.value}`
                },
                body: JSON.stringify({
                    EmpID: userId
                }),
            })
            .then(res => res.json())
            .then(data => {
                if (data.status == true) {
                    console.log('leave')
                    console.log(data)
                    setLeave(data.data)
                }
            })
    }

    const getholidayList = async (pagenumber) => {
        const response = await fetch(SERVER_URL + `api/holiday/office-holiday-list`,
            {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'authorization': `bearer ${token.value}`
                },
            })
            .then(res => res.json())
            .then(data => {
                if (data.status == true) {
                    setHolidaylist(data.result)
                }
            });
    }
    const handleSubmit = () => {
        setErr('green')
        setErrmsg('')
        setErrfromdatemsg('')
        setErrtodatemsg('')
        if (leave_type == '' || leave_type == null || leave_type == 'undefined' || leave_type == '0') {
            setErr('red')
            setErrmsg(' Is Required')
            return false
        }
        else if (fromdate == '' || fromdate == null || fromdate == 'undefined') {
            setErr('red')
            setErrfromdatemsg(' Is Required')
        }
        else if (todate == '' || todate == null || todate == 'undefined') {
            setErr('red')
            setErrtodatemsg(' Is Required')
        } else {
            if (id != '') {
                editLeave()
            } else {
                addLeave()
            }
        }
    }
    const editLeave = () => {
        const response = fetch(SERVER_URL + `api/leave/leave-update`,
            {
                method: 'PUT',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'authorization': `bearer ${token.value}`
                },
                body: JSON.stringify({
                    leaveId: id,
                    formDate: fromdate,
                    toDate: todate,
                    requestType: 3,
                    leaveType: leave_type,
                    leaveDuration: duration,
                    description: reason,
                    requestedBy: userId

                }),
            }).then(res => res.json())
            .then(data => {
                if (data.status == true) {
                    setMsg('Leave successfully updated')
                    setErr('green')
                    getLeaveList()
                    setTimeout(function () {
                        handleClose()
                    }, 1000);
                }
            });
    }
    const addLeave = () => {

        // alert(leave_type); return false;
        const userId = localStorage.getItem('userId');
        const response = fetch(SERVER_URL + `api/leave/apply-leave`,
            {
                method: 'post',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'authorization': `bearer ${token.value}`
                },
                body: JSON.stringify({
                    EmpID: userId,
                    requestType: 3,
                    formDate: fromdate,
                    toDate: todate,
                    leaveType: leave_type,
                    leaveDuration: duration,
                    durationDay: 1,
                    description: reason
                }),
            }).then(res => res.json())
            .then(data => {
                if (data.status == true) {
                    setMsg('Leave successfully added')
                    setErr('green')
                    getLeaveList()
                    setTimeout(function () {
                        handleClose()
                    }, 1000);
                }
            })
    }
    useEffect(() => {
        getLeaveList()
    }, [])
    function getLeaveList() {
        fetch(SERVER_URL + `api/leave/leave-history`, {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'authorization': `bearer ${token.value}`
            },
            body: JSON.stringify({
                empID: userId
            }),
        }).then(res => res.json())
            .then(data => {
               // console.log(data.data)
                setLeavelist(data.data)
            })
    }

    const dateConverter2 = (startDate, timeEnd) => {
        const newStartDate = new Date(startDate);
        const newEndDate = new Date(timeEnd);
        let result = moment(newStartDate).diff(newEndDate, 'days') + 1
        return result
    }
    const dateConverter = (startDate, timeEnd) => {
        const newStartDate = new Date(startDate);
        const newEndDate = new Date(timeEnd);
        let result = moment(newStartDate).diff(newEndDate, 'days') + 1
        return result > 1 ? result + ' Days' : result + 'Day'
    }
    const leave_type_arr = ["", "Earned Leave", "Casual Leave", "Sick Leave", "Leave Without Pay"];
    const HandleEdit = (id) => {
        fetch(SERVER_URL + `api/leave/leave-edit`, {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'authorization': `bearer ${token.value}`
            },
            body: JSON.stringify({
                leaveId: id
            }),
        }).then(res => res.json())
            .then(data => {
                setModalstatus(true)
                if (data.status == true) {
                    setLeave_type(data.data.leave_type)
                    setFromdate(moment(data.data.from_date).format('yyyy-MM-DD'))
                    setTodate(moment(data.data.to_date).format('yyyy-MM-DD'))
                    setReason(data.data.leave_remarks)
                    setId(data.data.id)
                }
            })
    }
    const HandleDelete = (id) => {
        fetch(SERVER_URL + `api/leave/leave-delete`,
            {
                method: 'PUT',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'authorization': `bearer ${token.value}`
                },
                body: JSON.stringify({
                    leaveId: id,
                    statusValue: '1',
                    requestedBy: userId

                }),
            }).then(res => res.json())
            .then(data => {
                if (data.status == true) {
                    getLeaveList()
                }
            });
    }
    function getTotalLeave(el, cl, sl) {
        var total = 'N/A';
        if ((el !== '' || el != null || el != undefined) && (cl !== '' || cl != null || cl != undefined) && (sl !== '' || sl != null || sl != undefined)) {
            var total = el + cl + sl;
            total = total == '' ? 'N/A' : total;
        }
        return total == 'NaN' ? 'N/A' : total;
    }
    const handleMSG = (id) => {
        const response = fetch(SERVER_URL + `api/leave/get-leave-remark`,
            {
                method: 'post',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'authorization': `bearer ${token.value}`
                },
                body: JSON.stringify({
                    leaveId: id
                }),
            }).then(res => res.json())
            .then(data => {
                if (data.status == true) {
                    setAtt_remark(data.data.remark)
                }
            })
        setModalcomment(true)



    }


    return (
        <div className='container-fluid'>
            <Modal show={modalcomment} size="sm" id="rejectmodal">
                <div className="modalheader">
                    <button type="button" className="float-end btn_close" onClick={handleClose} data-bs-dismiss="modal" aria-label="Close">
                        <i className="icon icon-cross"></i>
                    </button>
                    <img src="assets/images/cross_icon.png" alt="" />
                    <span className="arrow_down"></span>
                </div>
                <div className="modal-body">
                    <div class="dash_white_box_ttl text-center" id="exampleModalLabel">Reason of Rejection</div>
                    <div className="mb-2">
                        <textarea value={att_remark} className="form-control" placeholder="" >{att_remark}</textarea>
                    </div>
                </div>
            </Modal>
            <Modal show={modalstatus} size="md" id="confirm_login">
                <div className="modal-body">
                    <button type="button" className="float-end btn_close" onClick={handleClose} data-bs-dismiss="modal" aria-label="Close">
                        <i className="icon icon-cross"></i>
                    </button>
                    <div className="dash_white_box_ttl text-center" id="exampleModalLabel">{id != '' ? 'Edit Apply Leave' : 'Apply Leave'}</div>
                    <div className="mb-2">
                        <label className="col-form-label">Leave Type :<span style={{ color: err }}>{errmsg}</span></label>
                        <select value={leave_type} onChange={(e) => { setLeave_type(e.target.value) }} className="form-select">
                            <option value=''>Select Type</option>
                            <option value='1'>Earned Leave</option>
                            <option value='2'>Casual Leave</option>
                            <option value='3'>Sick Leave</option>
                            <option value='4'>Leave Without Pay</option>
                        </select>
                    </div>
                    <div className="mb-2">
                        <div className="row">
                            <div className="col-md-6">
                                <label className="col-form-label">From Date :<span style={{ color: err }}>{errfromdatemsg}</span></label>
                                {/* <input value={fromdate} onChange={(e) => { setFromdate(e.target.value) }} type="date" className="form-control" id="from-date" /> */}


                                <DatePicker
                                    placeholderText='YYYY-MM-DD'
                                    value={fromdate}
                                    id="datetime-local"
                                    date={fromdate}
                                    onChange={e => { setFromdate(moment(e).format("YYYY-MM-DD")) }}
                                    className="form-control"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    minDate={new Date(Date.now())}
                                />
                            </div>
                            <div className="col-md-6">
                                <label className="col-form-label">To Date :<span style={{ color: err }}>{errtodatemsg}</span></label>
                                {/* <input value={todate} onChange={(e) => { setTodate(e.target.value) }} type="date" className="form-control" id="to-date" /> */}


                                <DatePicker
                                    placeholderText='YYYY-MM-DD'
                                    value={todate}
                                    id="datetime-local"
                                    date={todate}
                                    onChange={e => {
                                        setTodate(moment(e).format("YYYY-MM-DD"));
                                        if (fromdate != '') {
                                            var cal_day = dateConverter2(moment(e).format("YYYY-MM-DD"), fromdate)
                                            if (cal_day > 1 || cal_day==1) {
                                                setDate_select(cal_day)
                                                setErr()
                                            } else {
                                                setDate_select('Date From to Date is not valid')
                                            }
                                        }
                                        //alert(ffff)
                                    }}
                                    className="form-control"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    minDate={new Date(Date.now())}
                                />
                            </div>
                        </div>
                        <label className="totalnumber " >Total Number of days - <span style={{color:"red"}}>{date_select}</span></label>
                    </div>
                    <div className="mb-2">
                        <label className="col-form-label">Duration :</label>
                        <select value={duration} onChange={(e) => { setDuration(e.target.value) }} className="form-select mb08" id="duration">
                            <option value="1">Full Day</option>
                            <option value="2">Half Day</option>
                        </select>
                        <div className="hide_halfday" style={{ display: duration == 2 ? 'block' : 'none' }}>
                            <select name='' className="form-select">
                                <option value=''>First Half</option>
                                <option value='1'>Second Half</option>
                            </select>
                        </div>
                    </div>
                    <div className="mb-2">
                        <label className="col-form-label">Reason</label>
                        <textarea value={reason} className="form-control" onChange={(e) => { setReason(e.target.value) }} cols="2" id="reason">{reason}</textarea>
                    </div>
                    <div className="mb-3">
                        <label className="col-form-label">Leave Balance</label>
                        <ul className="l_balnce">
                            <li className="lwp">CFL - 10</li>
                            <li className="cl">EL - 15</li>
                            <li className="sl">CL - 2</li>
                            <li className="sl">SL - 2</li>
                            <li className="el">TL - 20</li>
                            <li className="py">LWP - 0</li>
                        </ul>
                    </div>
                    <div className="modalfooter">
                        <span style={{ color: err }}>{msg}</span>
                        <button type="button" onClick={handleClose} className="btn_6 float-end ml10" data-bs-dismiss="modal">Cancel</button>
                        <button type="button" onClick={handleSubmit} className="btn_5 float-end ">Submit</button>
                    </div>
                </div>
            </Modal>
            <div className="dash_ttl">
                <button className="btn_5 mr10 float-end" onClick={HandleLeaveModal}>Apply Leave</button>
                Leave
            </div>
            <div className="crumbs">
                <ul id="breadcrumbs" className="breadcrumb">
                    <li>
                        <a href="dashboard.html">Dashboard </a>
                    </li>
                    <li className="current">
                        <span>/</span> Leave
                    </li>
                </ul>
            </div>
            <div className="row mb30">
                <div className="col-md-8">
                    <div className="dash_white_box2 mb20 p20">
                        <div className="dash_white_box_ttl">Leave Balance</div>
                        <ul className="leavebalance_wrp">
                            <li className="leavebalance_blk lwp">
                                <div className="leavebalance_num_blk leave_lwp">
                                    <div className="leavebalance">N/A</div>
                                </div>
                                <div className="leavebalance_ttl">Carry Forward</div>
                            </li>
                            <li className="leavebalance_blk cl">
                                <div className="leavebalance_num_blk leave_cl">
                                    <div className="leavebalance">{leave.el_leave ? leave.el_leave : 'N/A'}</div>
                                </div>
                                <div className="leavebalance_ttl">Earned Leave - EL</div>
                            </li>

                            <li className="leavebalance_blk sl">
                                <div className="leavebalance_num_blk leave_sl">
                                    <div className="leavebalance">{leave?.cl_leave ? leave.cl_leave : 'N/A'}</div>
                                </div>
                                <div className="leavebalance_ttl">Casual Leave - CL </div>
                            </li>
                            <li className="leavebalance_blk sl">
                                <div className="leavebalance_num_blk leave_sl">
                                    <div className="leavebalance">{leave?.sl_leave ? leave.sl_leave : 'N/A'}</div>
                                </div>
                                <div className="leavebalance_ttl">Sick Leave - SL</div>
                            </li>
                            <li className="leavebalance_blk el">
                                <div className="leavebalance_num_blk leave_el">
                                    <div className="leavebalance">{getTotalLeave(leave?.el_leave ? leave.el_leave : '', leave?.cl_leave ? leave.cl_leave : '', leave?.sl_leave ? leave.sl_leave : '')}</div>
                                </div>
                                <div className="leavebalance_ttl">Total Leave</div>
                            </li>
                            <li className="leavebalance_blk py">
                                <div className="leavebalance_num_blk leave_py">
                                    <div className="leavebalance">N/A</div>
                                </div>
                                <div className="leavebalance_ttl">Leave without pay</div>
                            </li>
                        </ul>
                    </div>
                    <div className="contentwrp content_wrp">
                        <div className="tab_wrapper tab_wrapper1">
                            <div className="dash_white_box_ttl">Leave History</div>
                            <table className="table_style_1">
                                <thead>
                                    <tr>
                                        <th>Leave Type</th>
                                        <th>Date</th>
                                        <th>Count</th>
                                        <th>Reason</th>
                                        <th>Status</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        leavelist?.map((item, ind) => {
                                            return <tr key={ind + 1}>
                                                <td> {item.request_type == 2 && <span className="avatar_icon">Rg</span>}
                                                    {item.request_type != 2 && <span className="avatar_icon">{leave_type_arr[item?.leave_type] ? leave_type_arr[item?.leave_type].match(/(\b\S)?/g).join("").match(/(^\S|\S$)?/g).join("").toUpperCase() : ''}</span>}

                                                </td>
                                                <td>

                                                    {item.request_type != 2 && <span>
                                                        {moment(item.from_date).format('DD MMM, yyyy')} - {moment(item.to_date).format('DD MMM, yyyy')}
                                                    </span>
                                                    }
                                                    {item.request_type == 2 && <span>
                                                        {moment(item.regularize_date).format('DD MMM, yyyy')} ({moment(item.start_time, ["HH:mm"]).format("hh:mm A")}-{moment(item.end_time, ["HH:mm"]).format("hh:mm A")})
                                                    </span>
                                                    }
                                                </td>
                                                <td>{dateConverter(new Date(item?.to_date), new Date(item?.from_date))}</td>
                                                <td>{item?.user_remarks}</td>
                                                <td> 
                                                    {(
                                                        function () {
                                                            if (item.status == 0) {
                                                                return <span className="badge bg-success">Pending</span>
                                                            }
                                                            if (item.status == 1) {
                                                                // return <span className='badge bg-primary'>Approved</span>
                                                                return <img className='avatar_icon' src={`${BASE_URL}assets/images/ok.png`} />
                                                            }
                                                            if (item.status == 3) {
                                                                return <img className='avatar_icon' src={`${BASE_URL}assets/images/not_ok.png`} />
                                                            }
                                                        }()
                                                    )}


                                                </td>
                                                <td >
                                                    {(
                                                        function () {
                                                            if (item.request_type == 2 && item.status == 0) {

                                                            }
                                                            if (item.request_type != 2 && item.status == 0) {
                                                                return <>
                                                                    <button onClick={(e) => { HandleEdit(item?.id) }} className="btn_7 mr03">Edit</button>
                                                                    <button className="btn_8" onClick={(e) => { HandleDelete(item?.id) }}>Delete</button>

                                                                </>
                                                            }
                                                            if (item.status == 1) {
                                                                return <span className="badge bg-success" onClick={(e) => { handleMSG(item.id) }}>MSG</span>
                                                            }
                                                            if (item.status == 3) {
                                                                return <span className="badge bg-success" onClick={(e) => { handleMSG(item.id) }}>MSG</span>
                                                            }

                                                        }()
                                                    )}
                                                </td>
                                            </tr>
                                        })
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div className="col-md-4">
                    <div className="dash_white_box2 mb20">
                        <div className="dash_white_box_ttl">List of Holidays</div>
                        <ul className="holiday_list_wrp">
                            {
                                holidaylist?.map((item, ind) => {
                                    return <li key={ind + 1} className="holiday_list_blk">
                                        <div className="holiday_list">
                                            <img src="assets/images/holidays.png" />
                                            <span>{moment(item.holiday_date).format('DD MMM, yyyy')}
                                            </span>
                                            <span>{moment(item.holiday_date).format('dddd')}</span>
                                        </div>
                                        <div className="holiday_list">
                                            <span>{item.level}</span>
                                            <span>{item?.holiday_type == 1 ? 'Restricted Holiday' : item?.holiday_type == 3 ? 'National Holiday' : item?.holiday_type == 2 ? 'Gazetted Holiday' : item?.holiday_type}</span>
                                        </div>
                                    </li>
                                })
                            }
                        </ul>
                        <p className="fs12">There are three National Holidays in India, 26th January, 15th August and 2nd October and there is a Major festivals (Holi- 7th March, 2023.)</p>
                    </div>
                </div>

            </div>



        </div>
    )
}

export default EmpLeaveCom
